"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmStepItem = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const useStep_1 = require("./useStep");
exports.SmStepItem = react_1.default.forwardRef((_a, ref) => {
    var { title, caption, status, className, selected, hoverable } = _a, props = __rest(_a, ["title", "caption", "status", "className", "selected", "hoverable"]);
    react_1.default.useContext(useStep_1.StepContext);
    const stepItemClassnames = (0, classnames_1.default)('c-step__item', {
        '-active': selected,
        '-hoverable': hoverable,
    }, `-${status}`, className);
    return (react_1.default.createElement("li", Object.assign({}, props, { className: stepItemClassnames, ref: ref }),
        react_1.default.createElement("div", { className: "c-step__indicator" }),
        react_1.default.createElement("div", { className: "c-step__content" },
            title && react_1.default.createElement("span", { className: "c-step__contentLabel" }, title),
            caption && react_1.default.createElement("span", { className: "c-step__contentCaption" }, caption))));
});
//# sourceMappingURL=SmStepItem.js.map